export const searchInternshipsPathByLocale = {
  en: '/en/internships',
  es: '/es/pasantias',
} as const;

export const searchInternshipsPaths = Object.values(
  searchInternshipsPathByLocale,
);

export const searchInternshipsPathsWithoutLang = Array.from(
  new Set(searchInternshipsPaths.map((path) => path.substring(3))),
);
